
export interface Operator {
  id: string
  key: string
  isAvailable: boolean
  isSelected: boolean
}

export enum OperatorLight {
  swde = "SWDE",
  proximus = "Proximus",
  orange = "Orange",
  resa = "RESA"
}

